import {createContext, PropsWithChildren, useMemo} from "react";
import {useSyncedRef} from "../../../misc/SyncedRef";

export const Task2CardContext = createContext({
    reload: () => {}
});

export function Task2CardProvider(props: PropsWithChildren<{
    onReload(): void;
}>) {
    const reloadRef = useSyncedRef(props.onReload);

    const ctx = useMemo(() => ({
        reload: () => reloadRef.current()
    }), [reloadRef]);

    return <Task2CardContext.Provider value={ctx}>
        {props.children}
    </Task2CardContext.Provider>
}